module.exports = __webpack_public_path__ + "resources/img/img_rancher_m_en.24d7f28512c440618c37ee5167aa8a06.png";